module.exports = __webpack_public_path__ + "static/media/history-red.21d4e385.svg";